// extracted by mini-css-extract-plugin
export default {"ratings":"LandlordRatingButtons_ratings__eczOs","big":"LandlordRatingButtons_big__UEJTW","ratingIcon":"LandlordRatingButtons_ratingIcon__EVRH7"};